/*!
 * @monogrid/vue-boost v1.2.0 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { tryOnUnmounted as l } from "@vueuse/core";
import { reactive as u, computed as r } from "vue";
import { getEnv as d } from "../../index2.mjs";
import { useOptimizedImage as f, OptimizedImageFitMode as a } from "../useOptimizedImage/index.mjs";
const e = u({
  title: void 0,
  description: "",
  defaultDescription: "",
  image: void 0,
  defaultImage: void 0,
  siteTitle: "Loading...",
  separator: "|"
}), c = ({ siteTitle: i, description: o, image: t, separator: n } = {}) => {
  const s = d();
  if (e.siteTitle = i || e.siteTitle, e.separator = n || e.separator, e.defaultDescription = o || e.defaultDescription, t)
    if (typeof t == "object") {
      const { url: p } = f(t, { width: 1200, height: 625, format: "jpg", fit: a.FIT_CROP });
      e.defaultImage = `https://${s.SERVICE_TARGET_DOMAIN}${p}`;
    } else
      e.defaultImage = t;
}, m = ({ title: i, description: o, image: t }) => {
  const n = d();
  if (e.title = i, e.description = o, t)
    if (typeof t == "object") {
      const { url: s } = f(t, { width: 1200, height: 625, format: "jpg", fit: a.FIT_CROP });
      e.image = `https://${n.SERVICE_TARGET_DOMAIN}${s}`;
    } else
      e.image = t;
  l(() => {
    e.title === i && (e.title = void 0), e.description === o && (e.description = void 0), e.image === t && (e.image = void 0);
  });
}, g = () => ({
  title: r(() => e.title ? `${e.title} ${e.separator} ${e.siteTitle}` : e.siteTitle),
  description: r(() => e.description || e.defaultDescription),
  image: r(() => e.image || e.defaultImage)
}), E = () => ({
  getReactiveSeo: g,
  setSeo: m,
  setSeoDefaults: c
});
export {
  E as default,
  E as useSeo
};
